<template>
  <div class="tenancy-tenancy">
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <hl-Toast
      v-if="getTenancy.subscription.subscriptionPlanName === 'Garantert'"
      :title="translate('tenancy.ddg.warning.title')"
      :text="translate('tenancy.ddg.warning.md-text')"
      variant="warning"
      class="mt-4 mb-3"
    />

    <TenancyContractHighlights :landlord-id="landlordId" :tenancy-id="tenancyId" />
    <TenancyRentInfo v-show="!isFree" :landlord-id="landlordId" :tenancy-id="tenancyId" class="my-4" />
    <TenancyTenant :landlord-id="landlordId" :tenancy-id="tenancyId" class="my-4" />
    <CustomerInformation :landlord-id="landlordId" :tenancy-id="tenancyId" class="my-4" />
    
    <TenancyAddendum :tenancy-id="Number(tenancyId)" />

    <div class="my-4 tenancy-tenancy__bank-index-wrapper">
      <TenancyCPIAdjustment
        ref="kpi"
        v-if="!isFree"
        class="flex-fill"
        :landlordId="landlordId"
        :tenancyId="tenancyId"
      />
      <TenancyBankInfo :landlordId="landlordId" :tenancyId="tenancyId" />
      <TenancyTerminate
        v-if="getTenancy.subscription.subscriptionPlanName !== 'Garantert' || isUserSudo"
        :landlord-id="landlordId"
        :tenancy-id="tenancyId"
        :class="{
          'tenancy-tenancy__sudo': getTenancy.subscription.subscriptionPlanName === 'Garantert' && isUserSudo,
        }"
      />
      <UpdateSubscription
        v-if="['Basic', 'Premium'].includes(getTenancy.subscription.subscriptionPlanName) || isUserSudo"
        :compact-layout="false"
        :landlordId="landlordId"
        :tenancyId="tenancyId"
        :class="{
          'tenancy-tenancy__sudo':
            !['Basic', 'Premium'].includes(getTenancy.subscription.subscriptionPlanName) && isUserSudo,
        }"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomerInformation from '@/components/profile/CustomerInformation.vue';
import TenancyCPIAdjustment from '@/components/tenancy/settings/TenancyCPIAdjustment';
import TenancyBankInfo from '@/components/tenancy/tenancy/TenancyBankInfo';
import TenancyContractHighlights from '@/components/tenancy/tenancy/TenancyContractHighlights';
import TenancyRentInfo from '@/components/tenancy/tenancy/TenancyRentInfo';
import TenancyTenant from '@/components/tenancy/tenancy/TenancyTenant';
import TenancyAddendum from '@/components/tenancy/tenancy/TenancyAddendum.vue';
import TenancyTerminate from '@/components/tenancy/tenancy/TenancyTerminate.vue';
import UpdateSubscription from '@/components/upsale/UpdateSubscription';
import i18nCommon from '@modules/i18n/mixins/Common';
import { getExampleNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import subscription from '@/mixins/tenancy/subscription';
import Toast from '@modules/husleie-framework/src/components/Toast.vue';

export default {
  mixins: [subscription, i18nCommon],
  props: {
    rentalObjectId: [String, Number],
    tenancyId: [String, Number],
    landlordId: [String, Number],
    defaultHeader: String,
  },
  data() {
    return {
      localTenancyCopy: null,
      plans: null,
      showUpgradeToPremiumModal: false,
    };
  },
  components: {
    CustomerInformation,
    TenancyContractHighlights,
    TenancyCPIAdjustment,
    TenancyRentInfo,
    TenancyTenant,
    TenancyAddendum,
    TenancyTerminate,
    TenancyBankInfo,
    UpdateSubscription,
    'hl-Toast': Toast,
  },
  computed: {
    ...mapGetters(['isUserSudo']),
    ...mapGetters('tenancy', ['getTenancy']),

    phoneExample() {
      const prefix = parsePhoneNumberFromString(this.newCoTenant.phonePrefix + '444');
      if (prefix) {
        const exampleObject = getExampleNumber(prefix.country, examples);

        if (exampleObject) {
          return exampleObject.formatNational();
        }
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.tenancy-tenancy__bank-index-wrapper,
.tenancy-tenancy__subscription-wrapper {
  @apply grid grid-cols-2 gap-4;
}

@media (max-width: 1200px) {
  .tenancy-tenancy__bank-index-wrapper,
  .tenancy-tenancy__subscription-wrapper {
    @apply grid grid-cols-1 gap-4;
  }
}
.tenancy-tenancy__sudo {
  border: 2px solid #ed2135;
  border-radius: $border-radius;
}
</style>
